module.exports = __webpack_public_path__ + "static/img/day2.eb0e486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour1/day2.jpg
// module id = BFNT
// module chunks = 0